<script>
import { Line } from 'vue-chartjs'

export default {
  extends: Line,
  props: {
    chartData: {
      type: Object,
      required: true,
      'default': () => ({}),
    },
    options: {
      type: Object,
      required: true,
      'default': () => ({}),
    }
  },
  mounted() {
    this.renderChart(this.chartData, this.options)
  },
  methods: {
    reRenderChart(chartData, options) {
      this.chartData = chartData;
      this.options = options;
      this.renderChart(this.chartData, this.options);
    }
  }
}

</script>